<script lang="ts">
import FlagIcon from "./flag-icon.svelte";
import flagData from "../flags.json";

export let flags: Flag[];
export let setFlags: (flags: Flag[]) => void;

$: pool = Object.values(flagData)
    .filter(f => !flags.find(s => s.name === f.name))
</script>

{#each [flags, pool] as flagArray, isPool}
    <div class="flag-container {isPool ? 'flagPool' : ''}">
        {#if flagArray.length}
            {#each flagArray as flag, i (flag.name)}
                <div class="flag">
                    <FlagIcon {flag} width=72 />
                    <p>{flag.name}</p>

                    {#if isPool}
                        <button 
                            class="add"
                            on:click={
                                () => setFlags([...flags, flagData[flag.id]])
                            }
                        >+</button>
                    {:else}
                        <button
                            class="remove"
                            on:click={
                                () => setFlags([...flags.slice(0, i), ...flags.slice(i + 1, flags.length)])
                            }
                        >×</button>
                    {/if}
                </div>
            {/each}
        {:else}
            {#if isPool}
                <p>that's all of them! :)</p>
            {:else}
                <p>add some flags to get started!</p>
            {/if}
        {/if}
    </div>
{/each}

<style lang="scss">
    .flag-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(9rem, 1fr));
        gap: 1rem 0.5rem;
        width: 100%;
        background-color: $light-gray;
        padding: 0.5rem 2rem;
        border-radius: 1.5rem;

        @media (max-width: $mobile-size) {
            padding: 0.5rem 1rem;
        }

        @media (prefers-color-scheme: dark) {
            background: $dark-gray;
        }

        & > p {
            grid-column: 1 / -1;
            text-align: center;
        }

        .flag {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            flex: 1 1 0px;
            padding: 0.5rem 1rem;
            gap: 0.25rem;

            p {
                margin: 0;
                line-height: 1rem;
                white-space: nowrap;
            }

            button {
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                padding: 0;
                pointer-events: all;
                transition: opacity 0.1s ease-out;
                border: none;
                cursor: pointer;
                font-size: 3rem;
                line-height: 3rem;
                color: white;

                &:hover {
                    opacity: 0.9;
                }
                &.add {
                    background: $green;
                }
                &.remove {
                    background: $red;
                }
            }
        }
    }
</style>
